import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=3815934b&scoped=true&"
import script from "./ListPage.vue?vue&type=script&lang=ts&"
export * from "./ListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=3815934b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3815934b",
  null
  
)

export default component.exports